class SiteConfig {
    static THEME = "light";
    static SITE_DOMAIN = "https://soda-stg.pages.dev";
    
    static BACKEND_DOMAIN = "https://stg-api.carbonpumpit.co";
    
    static PLEDGES_PDF_DOMAIN = "https://stg-pledges.carbonpumpit.co";
    
    static COGNITO_CLIENT_ID = "64rtcq6m4i6v2qmureuqbbrjmu";
    static COGNITO_DOMAIN = "https://soda-sr.auth.eu-west-1.amazoncognito.com";
    static COGNITO_AUTHORITY = "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_eC1bzswAS";
    static COGNITO_LOGOUT_URI = `${this.COGNITO_DOMAIN}/logout?client_id=${this.COGNITO_CLIENT_ID}&logout_uri=${encodeURIComponent(this.SITE_DOMAIN)}`
    
    static BLOCKCHAIN_SMART_CONTRACT = "0x8FFdf5B20C17c45f0Aed23EBc68AAe66ED12aFCf";
    static BLOCKCHAIN_GAS_STATION_URL = "https://gasstation-testnet.polygon.technology/v2";
    
    static SENTRY_ENVIRONMENT = "staging";
}

export default SiteConfig;